module.exports = {
  firebase: {
    apiKey: "AIzaSyBAnPpEYW7o3uriqL31Iiyw-ILz5KxDIqY",
    authDomain: "project-bluebox.firebaseapp.com",
    databaseURL: "https://project-bluebox-default-rtdb.firebaseio.com", // update this
    projectId: "project-bluebox",
    storageBucket: "project-bluebox.firebasestorage.app",
    messagingSenderId: "273601734713",
    appId: "1:273601734713:web:1a02a2a18a7bec1f15c5e8",
    measurementId: "G-TS023CYV9D" 
  }
}

